export default "__VITE_ASSET__BbHcgcs9__"